module.exports = __webpack_public_path__ + "static/media/for_students.ac6c659c.png";